export enum WellKnownAdminSubTypes {
  corporate = 1,
  personal = 2,
}
